module.exports = __webpack_public_path__ + "static/media/graph-application.5db1edf2.png";